import React from 'react';
import { Box, Typography, Grid } from '@mui/joy';
import MetricCard from './MetricCard';

const SubmittalAnalytics = ({ submittals }) => {
  const now = new Date();
  const overdue = submittals.filter(s =>
    s.deadline &&
    new Date(s.deadline) < now &&
    !s.submittal_date
  ).length;

  const dueSoon = submittals.filter(s =>
    s.deadline &&
    !s.submittal_date &&
    new Date(s.deadline) >= now &&
    new Date(s.deadline) <= new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000)
  ).length;

  const onHold = submittals.filter(s => s.on_hold).length;

  const closed = submittals.filter(s =>
    s.submittal_date &&
    s.deadline &&
    new Date(s.deadline) <= now
  ).length;

  const total = submittals.length;

  const getGradientColors = (type) => {
    switch (type) {
      case 'overdue':
        return ['#dc3545', '#c82333'];
      case 'dueSoon':
        return ['#ffc107', '#e0a800'];
      case 'onHold':
        return ['#6c757d', '#5a6268'];
      case 'closed':
        return ['#28a745', '#218838'];
      case 'total':
        return ['#00A884', '#007E33'];
      default:
        return ['#00A884', '#007E33'];
    }
  };

  const getIcon = (type) => {
    switch (type) {
      case 'overdue':
        return 'error';
      case 'dueSoon':
        return 'schedule';
      case 'onHold':
        return 'pause_circle';
      case 'closed':
        return 'check_circle';
      case 'total':
        return 'receipt_long';
      default:
        return 'receipt_long';
    }
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Typography 
        level="h3" 
        sx={{ 
          mb: 3, 
          color: 'success.700',
          display: 'flex',
          alignItems: 'center',
          gap: 2
        }}
        className="fade-in"
      >
        <span className="material-symbols-outlined" style={{ fontSize: '32px', fontFamily: 'Material Symbols Outlined' }}>
          timeline
        </span>
        Submittal Overview
      </Typography>
      
      <Grid container spacing={3} className="fade-in-up">
        <Grid xs={12} sm={6} md={2.4}>
          <MetricCard
            title="Overdue"
            value={overdue}
            icon={getIcon('overdue')}
            gradientColors={getGradientColors('overdue')}
          />
        </Grid>
        <Grid xs={12} sm={6} md={2.4}>
          <MetricCard
            title="Due Soon"
            value={dueSoon}
            icon={getIcon('dueSoon')}
            gradientColors={getGradientColors('dueSoon')}
          />
        </Grid>
        <Grid xs={12} sm={6} md={2.4}>
          <MetricCard
            title="On Hold"
            value={onHold}
            icon={getIcon('onHold')}
            gradientColors={getGradientColors('onHold')}
          />
        </Grid>
        <Grid xs={12} sm={6} md={2.4}>
          <MetricCard
            title="Completed"
            value={closed}
            icon={getIcon('closed')}
            gradientColors={getGradientColors('closed')}
          />
        </Grid>
        <Grid xs={12} sm={6} md={2.4}>
          <MetricCard
            title="Total"
            value={total}
            icon={getIcon('total')}
            gradientColors={getGradientColors('total')}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SubmittalAnalytics;